import { ChatSignalRService } from '#services/chat-signalr/chat-signalr.service';
import { PushNotificationService } from '#services/push-notification/push-notification.service';
import { SignalRService } from '#services/signalr/signalr.service';
import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';
export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const signalRService = inject(SignalRService);
    const chatSignalRService = inject(ChatSignalRService);
    const pushNotificationService = inject(PushNotificationService);
    // Fork join multiple API endpoint calls to wait all of them to finish
    signalRService.startConnection();
    chatSignalRService.startConnection();
    pushNotificationService.initialize();
    return forkJoin([
        navigationService.get(),
    ]);
};
